import {
  finishTaxCertApplication,
  setTaxCertApplicationError,
  setTaxCertApplicationNumber,
  startTaxCertApplication,
} from './taxCertificateSlice';
import { AppThunk } from 'src/store/store';
import api from 'src/api';
import { ApplicationData } from 'src/types/flow';
import { setCurrentStep, setStepCompletedStatus } from '../flow/flowSlice';

const APPLICATION_ERROR =
  'An error occurred while attempting to create the tax certificate.';

export const confirmTaxCertificate = (
  data: ApplicationData
): AppThunk<void, typeof api> => {
  return async (dispatch, getState) => {
    try {
      dispatch(startTaxCertApplication(data));
      const applicationData = getState().taxCertificate
        ?.applicationData as ApplicationData;

      const { applicationNumber } = await api.createNewTaxCertificate(
        applicationData,
        getState()
      );
      dispatch(setTaxCertApplicationNumber(applicationNumber));

      const selectedCurrentStep = getState().flow.currentStep;
      dispatch(
        setStepCompletedStatus({ stepNum: selectedCurrentStep, status: true })
      );
      dispatch(setCurrentStep(selectedCurrentStep + 1));
      dispatch(finishTaxCertApplication());
    } catch (err: unknown) {
      if (err instanceof Error) {
        dispatch(setTaxCertApplicationError(err.message));
      } else {
        dispatch(setTaxCertApplicationError(APPLICATION_ERROR));
      }
    }
  };
};
